import { render, staticRenderFns } from "./setup-help-bubble.vue?vue&type=template&id=ab90ca5c&scoped=true&"
import script from "./setup-help-bubble.vue?vue&type=script&lang=js&"
export * from "./setup-help-bubble.vue?vue&type=script&lang=js&"
import style0 from "./setup-help-bubble.vue?vue&type=style&index=0&id=ab90ca5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab90ca5c",
  null
  
)

export default component.exports